import { Square3Stack3DIcon } from '@heroicons/react/24/outline';
import type { PermissionLookup } from '../iamLookups';
import { AccessCard } from '../primitives/AccessCard';
import { RoleFlow } from '../primitives/RoleFlow';
import type { RoleFlowNode } from '../primitives/roleFlowTree';

interface RoleIncludeTreeCardProps {
    root: RoleFlowNode;
    permissionLookup: PermissionLookup;
}

// Card 2: how this entry is composed. Thin wrapper - RoleFlow owns the
// bounded-scroll viewport so a deep include graph doesn't stretch this card.
export function RoleIncludeTreeCard({ root, permissionLookup }: RoleIncludeTreeCardProps) {
    return (
        <AccessCard icon={Square3Stack3DIcon} title="Include tree">
            <RoleFlow root={root} permissionLookup={permissionLookup} />
        </AccessCard>
    );
}
